export default {
  id: null,
  createdAt: null,
  hsmId: null,
  hsmName: null,
  hsmText: null,
  variaveisHsmList: [],
  variaveisHsmTextoList: [],
  provedor: null,
  hasImage: false,
  hsmImageId: null,
  buttonCTA: false
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/hsmmodel.js